export class sortingHistory {
    public key: String;
    public status: boolean;
}